import { styled } from 'styletron-react';
import { TechemTheme } from '@techem/techem-theme';

const InlineLink = styled('span', {
  color: TechemTheme.colors.primary,
  userSelect: 'none',
  cursor: 'pointer',
  ':focus': {
    textDecoration: 'underline'
  },
  ':hover': {
    textDecoration: 'underline'
  }
});

export default InlineLink;
